type ShippingInfoWithFreeStandardShipping = {
  warrantyAndReturns: {
    additionalInfo: {
      freeStandardShipping: object;
    };
  };
};

export type WithFreeStandardShippingStatus<T extends ShippingInfoWithFreeStandardShipping> = Omit<
  T,
  'warrantyAndReturns'
> & {
  warrantyAndReturns: Omit<T['warrantyAndReturns'], 'additionalInfo'> & {
    additionalInfo: Omit<T['warrantyAndReturns']['additionalInfo'], 'freeStandardShipping'> & {
      freeStandardShipping: T['warrantyAndReturns']['additionalInfo']['freeStandardShipping'] & {
        status?: number;
      };
    };
  };
};

export function withFreeStandardShippingStatus<T extends ShippingInfoWithFreeStandardShipping>(
  shippingInfo: T,
  status: number | undefined,
): WithFreeStandardShippingStatus<T> {
  return {
    ...shippingInfo,
    warrantyAndReturns: {
      ...shippingInfo.warrantyAndReturns,
      additionalInfo: {
        ...shippingInfo.warrantyAndReturns.additionalInfo,
        freeStandardShipping: {
          ...shippingInfo.warrantyAndReturns.additionalInfo.freeStandardShipping,
          status,
        },
      },
    },
  } as WithFreeStandardShippingStatus<T>;
}
